module.exports = __webpack_public_path__ + "assets/webgl/wp_painted_concrete_color.jpg.1696e2ba.webp";